import { render, staticRenderFns } from "./indexCsg.vue?vue&type=template&id=620ce4e3&scoped=true"
import script from "./indexCsg.vue?vue&type=script&lang=js"
export * from "./indexCsg.vue?vue&type=script&lang=js"
import style0 from "./indexCsg.vue?vue&type=style&index=0&id=620ce4e3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ce4e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('620ce4e3')) {
      api.createRecord('620ce4e3', component.options)
    } else {
      api.reload('620ce4e3', component.options)
    }
    module.hot.accept("./indexCsg.vue?vue&type=template&id=620ce4e3&scoped=true", function () {
      api.rerender('620ce4e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/channel/online/flowdistribution/indexCsg.vue"
export default component.exports